export default __webpack_public_path__ + "static/B0052-d9d9e7a74ef958923789ce79eb915b28.png";